import { styled } from "@mui/material";

export const PasswordRecoveryWrapper = styled("form")(() => {
    return {
        display: "flex",
        flexDirection: "column",
        gap: "var(--flex-gap)",
        "& legend": {
            marginBlockStart: "calc(var(--basic-margin)/2)",
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
        "& .call-to-action": {
            overflow: "hidden",
            "& button": {
                marginBlockStart: "var(--basic-margin)",
            }
        },
    }
})